/** Combobox/portal above the fixed Developer Panel (z-index 1000). */
export const DEV_TOOLS_COMBOBOX_PROPS = {
  withinPortal: true,
  zIndex: 10_000,
} as const;
